import { Stack } from '@mui/material'
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import type { SxProps, Theme } from '@mui/system'
import { ReactComponent as CloseLogo } from 'assets/cross_close_logo.svg'
import React, { ReactElement } from 'react'
import { COLORS } from 'styles/colors'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'
import { TypographyHeader } from 'ui/typography/TypographyHeader'

interface ModalProps {
	open: boolean
	onClose: () => void
	title: string | ReactElement
	children: ReactElement
	onDismiss?: () => void
	onSave?: () => void
	onSaveText?: string
	onDismissText?: string
	sx?: SxProps<Theme>
}

const Modal: React.FC<ModalProps> = ({
	open,
	onClose,
	onSave,
	onDismiss,
	title,
	children,
	onSaveText,
	onDismissText,
	sx,
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: {
					borderRadius: '12px',
					p: '32px 24px',
					boxShadow: 'none',
					width: 650,
					...(sx || {}),
				},
			}}
		>
			<Box>
				<Stack
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
					mb={'24px'}
				>
					<TypographyHeader id='exit-warning-dialog-title'>
						{title}
					</TypographyHeader>
					<CloseLogo
						stroke={COLORS.icon}
						style={{ cursor: 'pointer' }}
						onClick={onClose}
					/>
				</Stack>
				{children}
				{(onSave || onDismiss) && (
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							gap: '24px',
							marginTop: '16px',
						}}
					>
						{onSave && (
							<OutlinedButton sx={{ margin: '0px' }} onClick={onSave} fullWidth>
								{onSaveText}
							</OutlinedButton>
						)}
						{onDismiss && (
							<OutlinedButton
								sx={{
									margin: '0px',
									borderColor: COLORS.error,
									color: COLORS.error,
									'&:hover': {
										opacity: 0.7,
										backgroundColor: 'transparent',
										color: COLORS.error,
										boxShadow: 'none',
									},
								}}
								onClick={onDismiss}
								fullWidth
							>
								{onDismissText}
							</OutlinedButton>
						)}
					</Box>
				)}
			</Box>
		</Dialog>
	)
}

export default Modal
